var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListTodo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 11.333L3.33333 12.6663L6 9.99967M8.66667 3.99967L14 3.99967M8.66667 7.99967L14 7.99967M8.66667 11.9997H14M2.66667 3.33301L5.33333 3.33301C5.70152 3.33301 6 3.63148 6 3.99967L6 6.66634C6 7.03453 5.70152 7.33301 5.33333 7.33301L2.66667 7.33301C2.29848 7.33301 2 7.03453 2 6.66634L2 3.99967C2 3.63148 2.29848 3.33301 2.66667 3.33301Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListTodo);
export default __webpack_public_path__ + "static/media/ListTodo.8c7e17e90c50a6b9d6d273e13b345dc4.svg";
export { ForwardRef as ReactComponent };